import { render, staticRenderFns } from "./EmailVariables.vue?vue&type=template&id=59c720ad&scoped=true&"
import script from "./EmailVariables.vue?vue&type=script&lang=js&"
export * from "./EmailVariables.vue?vue&type=script&lang=js&"
import style0 from "./EmailVariables.vue?vue&type=style&index=0&id=59c720ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c720ad",
  null
  
)

export default component.exports